import React from 'react';
import { Layout, AppBar, Menu, Sidebar } from 'react-admin';
import { Typography, Box, IconButton, Tooltip } from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import HomeIcon from '@mui/icons-material/Home';

const MyAppBar = (props) => {
  const { onBackToHome } = props;
  
  return (
    <AppBar
      {...props}
      sx={{
        '& .RaAppBar-title': {
          flex: 1,
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        },
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
        <Box display="flex" alignItems="center">
          <StorefrontIcon sx={{ mr: 1 }} />
          <Typography variant="h6" color="inherit">
            MyAdmin - La Ferme À L'Ancienne
          </Typography>
        </Box>
        {onBackToHome && (
          <Tooltip title="Retour à la page d'accueil">
            <IconButton
              color="inherit"
              onClick={onBackToHome}
              sx={{ ml: 2 }}
            >
              <HomeIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </AppBar>
  );
};

const MySidebar = (props) => (
  <Sidebar
    {...props}
    sx={{
      '& .RaSidebar-drawerPaper': {
        backgroundColor: '#f5f5f5',
      },
    }}
  >
    <Menu />
  </Sidebar>
);

export const MyLayout = (props) => {
  const { onBackToHome, ...layoutProps } = props;
  
  return (
    <Layout
      {...layoutProps}
      appBar={(appBarProps) => <MyAppBar {...appBarProps} onBackToHome={onBackToHome} />}
      sidebar={MySidebar}
      sx={{
        '& .RaLayout-content': {
          backgroundColor: '#fafafa',
        },
      }}
    />
  );
};